import Modal from "../../../../modals/user";
import React, {useState} from "react";
import {Button} from "@mui/material";


export default function Index(props){

    const {sizeType} = props

    const [modalOpen, setModalOpen] = useState(false);

    const openModal=()=>{
        setModalOpen(true);
    };
    const closeModal=()=>{
        setModalOpen(false);
    }

    return(
        <>
            <Button
                variant="contained"
                size="large"
                onClick={openModal}
                sx={{marginRight:2}}
            >
                신규 생성
            </Button>
            {modalOpen && <>
                {sizeType === 'mobile' ? (
                    <>
                        <Modal open={modalOpen} close={closeModal} header="신규 생성"
                               sizeType="mobile"  />
                    </>
                ):(
                    <>
                        <Modal open={modalOpen} close={closeModal} header="신규 생성"  />
                    </>
                )}
            </>}
        </>
    )
}